import { render, staticRenderFns } from "./legalCheck.vue?vue&type=template&id=44fdd663&"
import script from "./legalCheck.vue?vue&type=script&lang=ts&"
export * from "./legalCheck.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports